var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-card',{staticClass:"admin-tab",attrs:{"flat":""}},[_c('q-card-section',{staticClass:"bg-white fit tables-wrapper"},[_c('CredentialsTable'),_c('MasterArticleDataSourcesTable')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }